import { match } from 'ts-pattern'
import classnames from 'classnames/bind'
import * as graph from '@adc/sdk'
import { Text, withApplicationContext } from '@adc/ui-adc'
import styles from '../styles.scss'

const cx = classnames.bind(styles)

type ContactInformationSubtitleProps = {
  anwser: Record<string, any>
}

const ContactInformationSubtitle = ({
  anwser,
}: ContactInformationSubtitleProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const intentSelection = anwser?.['property.seller_intent'] as string
  return (
    <>
      <Text
        size='large'
        className={cx('intent-subtitle')}
        elmId='intent-subtitle-text'
      >
        {match({ intentSelection })
          .with(
            { intentSelection: graph.enums.SellerIntentType.Speed as string },
            () =>
              `Let us know how we can reach you to help you get your home sold quickly.`
          )
          .with(
            { intentSelection: graph.enums.SellerIntentType.Value as string },
            () =>
              `Let us know how we can reach you to help you maximize your home's sale price.`
          )
          .with(
            {
              intentSelection: graph.enums.SellerIntentType
                .Flexibility as string,
            },
            () =>
              `Let us know howe can reach you to help you with the most flexible home sale options.`
          )
          .otherwise(() => `Let us know how we can reach you?`)}
      </Text>
      <Text
        size='mini'
        className={cx('u-mt-1', 'u-mb-4')}
        elmId='all-fields-required-text'
      >
        (All Fields Required)
      </Text>
    </>
  )
}

export default withApplicationContext(ContactInformationSubtitle)
